<div id="eas-errors">
    <ub-alert *ngFor="let notification of notifications$ | async"
              [variant]="notificationType2Appearance(notification.type)">
        <span message [innerHTML]="notification.message"></span>
    </ub-alert>
</div>